import { Link } from "react-router-dom";

export const CrestMark = ({ size = 40, className = "" }) => (
  <img
    src="/assets/mark.png"
    alt=""
    data-testid="crestmark-img"
    className={className}
    style={{ width: size, height: size, objectFit: "contain", filter: "brightness(0) invert(1)" }}
  />
);

const Logo = ({ compact = false }) => (
  <Link to="/" className="flex items-center group" data-testid="brand-logo-link">
    <span className="inline-flex items-center bg-white rounded-lg px-2.5 py-1.5 shadow-[0_2px_18px_rgba(255,255,255,0.07)] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:shadow-[0_4px_24px_rgba(255,255,255,0.14)]">
      <img
        src="/assets/logo.png"
        alt="Crestmont Enterprises Private Limited"
        className={`w-auto ${compact ? "h-7" : "h-9"}`}
      />
    </span>
  </Link>
);

export default Logo;
